import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as participantActions from '../../../actions/participant';
import ParticipantResultHistoryForm from '../../../components/participant/participant-result-history-form';
import LocalizedStrings from '../../../localization/strings';
import Loading from '../../../components/loading';
import ParticipantResultsDisplay from '../../../components/participant-results-display';

class ParticipantResultsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchParams: null
        };
    }

    executeSearch(params) {
        this.setState({
            searchParams: params
        });
        return this.props.actions.submitAdminParticipantResultsSearch(params);
    }

    render() {
        const {participant_results} = this.props;
        return (
            <div>
                <h3>{LocalizedStrings.participantResults}</h3>

                <div className="panel">
                    <div className="panel-body">
                        <ParticipantResultHistoryForm submit={this.executeSearch.bind(this)}/>

                        {this.props.participant_results.loading
                            ? <Loading/>
                            :
                            <ParticipantResultsDisplay searchParams={this.state.searchParams}
                                                       items={participant_results.items || []}
                                                       extraCols={[
                                                           {
                                                               header: '', value: (item) => {
                                                                   return <a
                                                                       href={`/admin/participant-results/${item.id}`}
                                                                       className="btn">{LocalizedStrings.edit}
                                                                   </a>;
                                                               }
                                                           }
                                                       ]}/>}
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(function (state) {
    return {participant_results: state.admin.participant.participant_results};
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...participantActions
        }, dispatch)
    };
})(ParticipantResultsContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/participant-results/participant-results-container.js